<style scoped>
.main-list {
  height: 100%;
  margin: 0;
  padding: 0;
}

.list-container {
  height: calc(100% - 53px);
  overflow: auto;
  margin: 0;
  padding: 0;
}

.btn {
  height: 30px;
  margin-top: 1em;
}
</style>

<template>
  <div class="main-list">
    <v-banner>
      <v-spacer></v-spacer>{{ datasVeilleCO2.length }}&nbsp; résultats
    </v-banner>
    <v-row class="list-container">
      <v-col v-for="(item, i) in datasVeilleCO2" :key="i" cols="12">
        <v-card>
          <v-card-title class="title-projet">
            <v-chip >
              <span style="text-transform: uppercase;">{{ item.Projet.toLowerCase() }}</span>
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn class="btn" color="primary" text @click="clicFocusVille(item)">
              {{ item["Situation géographique"] ? item["Situation géographique"] : "" }}
              <i class="fa fa-map-marked"></i>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col v-for="header in headers" :key="header" cols="4">
                <div v-if="['Type de projet'].includes(header)">
                  {{ header }} :  <v-chip label class="mr-2" size="small" variant="elevated" color="#86B404" v-if="item[header]" v-for="val in item[header].split(';#')">{{ val }}</v-chip>
             
                </div>
                <div v-else>
                  {{ header }} : {{ item[header] }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-chip label class="mr-2" size="default" variant="elevated" color="#86B404" v-on:click="clicEnSavoirPlus(item)">
              En savoir plus
            </v-chip>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  props: {
    selectedItemsVeilleCO2: { type: Array, default: function () { return [] } },
  },

  data: () => ({
    headers: ["Type de projet", "Date de départ", "Date de FIN", "Porteur(s) du projet", "statut"] 
  }),
  computed: {
    datasVeilleCO2() {
      if (this.selectedItemsVeilleCO2 && this.selectedItemsVeilleCO2[0]) {
        return this.selectedItemsVeilleCO2.map((item, key) => {
          item._id = key;
          return item
        });

      } else {
        return []
      }
    }
  },
  methods: {
    clicEnSavoirPlus(item) {
      this.$emit("clicEnSavoirPlus", item)
    },
    clicFocusVille(item) {
      console.log(item["Longitude"])
      if (item["Longitude"] || item["Longitude"] !== "") {
        this.$emit("clicFocusVille", item)
      }
    },

  }
}
</script>